

import React, { useState, useEffect, useMemo, useRef } from "react";
import { FaSearch, FaPrint, FaCertificate } from "react-icons/fa";
import { FiMoreVertical } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import {
  GetCertificateList,
  UpdateCertificate,
  DeleteCertificate,
  GenarateCertifacate,
  printCertificate,
} from "../../../api/Webservices";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import { useUser } from "../../AdminUsers/UserContext";
import ConfirmationModal from "../../ReuseUI/ConfirmModel";
import SmallSpinner from "../../ReuseUI/Spinner";
import CertificatePrintPreviewModal from "./CertificatePrintPreviewModal";

const CertificateList = () => {
  const { checkPermission } = useUser();
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [certificateToDelete, setCertificateToDelete] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Styles
  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f8fafc",
      padding: "24px 15px",
    },
    headerCard: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow:
        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      padding: "20px 24px",
      marginBottom: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "16px",
    },
    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
    },
    headerIconBadge: {
      width: "44px",
      height: "44px",
      backgroundColor: "#1e3a5f",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#ffffff",
      fontSize: "20px",
    },
    headerTitle: {
      fontSize: "20px",
      fontWeight: "700",
      color: "#1e293b",
      margin: 0,
    },
    createButton: {
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 20px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      transition: "all 0.2s ease",
    },
    filterCard: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow:
        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      padding: "16px 24px",
      marginBottom: "20px",
    },
    filterRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "16px",
    },
    tabsContainer: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
    },
    tab: {
      padding: "10px 18px",
      borderRadius: "8px",
      border: "none",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s ease",
      backgroundColor: "#f1f5f9",
      color: "#64748b",
    },
    tabActive: {
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
    },
    searchContainer: {
      position: "relative",
      minWidth: "280px",
    },
    searchIcon: {
      position: "absolute",
      left: "14px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#9ca3af",
      fontSize: "16px",
    },
    searchInput: {
      width: "100%",
      padding: "12px 16px 12px 42px",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      fontSize: "14px",
      outline: "none",
      transition: "border-color 0.2s ease",
      backgroundColor: "#ffffff",
    },
    tableCard: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow:
        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      overflow: "hidden",
      marginBottom: "24px",
    },
    entriesRow: {
      padding: "16px 24px",
      borderBottom: "1px solid #e5e7eb",
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    entriesLabel: {
      fontSize: "14px",
      color: "#64748b",
      fontWeight: "500",
    },
    entriesSelect: {
      padding: "8px 12px",
      border: "1px solid #e2e8f0",
      borderRadius: "6px",
      fontSize: "14px",
      outline: "none",
      cursor: "pointer",
      backgroundColor: "#ffffff",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    tableHeader: {
      backgroundColor: "#f8fafc",
      borderBottom: "2px solid #e5e7eb",
    },
    th: {
      padding: "16px 20px",
      textAlign: "left",
      fontSize: "13px",
      fontWeight: "700",
      color: "#374151",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
    },
    tr: {
      borderBottom: "1px solid #f1f5f9",
      transition: "background-color 0.15s ease",
    },
    td: {
      padding: "16px 20px",
      fontSize: "14px",
      color: "#1e293b",
      verticalAlign: "middle",
    },
    certificateNameCell: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    certificateIcon: {
      width: "40px",
      height: "40px",
      backgroundColor: "#fef3c7",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#f59e0b",
      fontSize: "18px",
    },
    certificateTitle: {
      fontWeight: "600",
      color: "#1e293b",
    },
    toggleContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    toggleSwitch: {
      width: "52px",
      height: "28px",
      backgroundColor: "#e2e8f0",
      borderRadius: "14px",
      position: "relative",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    toggleSwitchActive: {
      backgroundColor: "#1e3a5f",
    },
    toggleKnob: {
      width: "22px",
      height: "22px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      position: "absolute",
      top: "3px",
      left: "3px",
      transition: "transform 0.3s ease",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    },
    toggleKnobActive: {
      transform: "translateX(24px)",
    },
    actionButton: {
      width: "36px",
      height: "36px",
      borderRadius: "8px",
      border: "none",
      backgroundColor: "#f1f5f9",
      color: "#64748b",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
    },
    actionMenu: {
      position: "absolute",
      top: "100%",
      right: "0",
      marginTop: "4px",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
      border: "1px solid #e5e7eb",
      overflow: "hidden",
      zIndex: 1000,
      minWidth: "140px",
    },
    actionMenuItem: {
      padding: "12px 16px",
      fontSize: "14px",
      color: "#374151",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      transition: "background-color 0.15s ease",
    },
    actionMenuItemDanger: {
      color: "#dc2626",
    },
    generateButton: {
      padding: "8px 16px",
      borderRadius: "6px",
      border: "none",
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
      fontSize: "13px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s ease",
      minWidth: "90px",
    },
    printButton: {
      padding: "8px 14px",
      borderRadius: "6px",
      border: "1px solid #e2e8f0",
      backgroundColor: "#ffffff",
      color: "#64748b",
      fontSize: "16px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paginationContainer: {
      padding: "16px 24px",
      borderTop: "1px solid #e5e7eb",
      backgroundColor: "#f9fafb",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "12px",
    },
    paginationInfo: {
      fontSize: "14px",
      color: "#64748b",
    },
    paginationButtons: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },
    pageButton: {
      padding: "8px 14px",
      borderRadius: "6px",
      border: "1px solid #e2e8f0",
      backgroundColor: "#ffffff",
      color: "#374151",
      fontSize: "14px",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    pageButtonActive: {
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
      border: "1px solid #1e3a5f",
    },
    errorBanner: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "16px 24px",
      backgroundColor: "#fef2f2",
      borderBottom: "1px solid #fecaca",
      color: "#991b1b",
      fontSize: "14px",
    },
    loadingContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "60px 24px",
    },
    spinner: {
      width: "44px",
      height: "44px",
      border: "4px solid #e5e7eb",
      borderTop: "4px solid #1e3a5f",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    loadingText: {
      marginTop: "16px",
      color: "#64748b",
      fontSize: "14px",
    },
  };

  const handleNavige = () => {
    history.push("/events/admin/certificate");
  };

  const loadCertificates = () => {
    setLoading(true);
    GetCertificateList()
      .then((res) => {
        if (res && res.data) {
          const formattedCertificates = res.data.map((certificate) => ({
            id: certificate.id,
            title: certificate.title,
            template: certificate.template,
            event_id: certificate.event_id,
            event_ticket: certificate.event_ticket,
            created_at: new Date(certificate.created_at).toLocaleDateString(
              "en-US",
              {
                day: "numeric",
                month: "short",
                year: "numeric",
              }
            ),
            status: certificate.status === 1 ? "active" : "inactive",
            _originalData: certificate,
          }));
          setCertificates(formattedCertificates);
        }
        setLoading(false);
        setApiError(null);
      })
      .catch((err) => {
        console.error("Error loading certificates:", err);
        setLoading(false);
        setApiError("Failed to load certificates. Please try again.");
      });
  };

  useEffect(() => {
    loadCertificates();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredCertificates = useMemo(() => {
    return certificates.filter((certificate) => {
      const matchesSearch =
        !searchTerm ||
        certificate.title.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesFilter =
        activeFilter === "all" ||
        (activeFilter === "active" && certificate.status === "active") ||
        (activeFilter === "inactive" && certificate.status === "inactive");
      return matchesSearch && matchesFilter;
    });
  }, [certificates, searchTerm, activeFilter]);

  const paginatedCertificates = useMemo(() => {
    const startIndex = (currentPage - 1) * entriesPerPage;
    return filteredCertificates.slice(startIndex, startIndex + entriesPerPage);
  }, [filteredCertificates, currentPage, entriesPerPage]);

  const totalPages = Math.ceil(filteredCertificates.length / entriesPerPage);

  const filterCounts = useMemo(
    () => ({
      all: certificates.length,
      active: certificates.filter((c) => c.status === "active").length,
      inactive: certificates.filter((c) => c.status === "inactive").length,
    }),
    [certificates]
  );

  const StatusToggle = ({
    status,
    certificateId,
    certificateTemplate,
    CertificateTitle,
  }) => {
    const [currentStatus, setCurrentStatus] = useState(status);
    const [isLoading, setIsLoading] = useState(false);

    const handleToggle = async () => {
      setIsLoading(true);
      const newStatus = currentStatus === "active" ? 0 : 1;
      try {
        const payload = {
          id: certificateId,
          status: newStatus,
          title: CertificateTitle,
          template: certificateTemplate,
        };
        const res = await UpdateCertificate(payload);
        if (res && res.success) {
          setCurrentStatus(newStatus === 1 ? "active" : "inactive");
          setCertificates((prev) =>
            prev.map((c) =>
              c.id === certificateId
                ? { ...c, status: newStatus === 1 ? "active" : "inactive" }
                : c
            )
          );
          showToast(
            `Certificate ${
              newStatus === 1 ? "activated" : "deactivated"
            } successfully!`,
            newStatus === 1 ? "success" : "error"
          );
        } else {
          showToast(res.message || "Failed to update status", "error");
        }
      } catch (error) {
        console.error("Error updating certificate status:", error);
        showToast("Failed to update status. Please try again.", "error");
      } finally {
        setIsLoading(false);
      }
    };

    const isActive = currentStatus === "active";

    return (
      <div style={styles.toggleContainer}>
        <div
          onClick={!isLoading ? handleToggle : undefined}
          style={{
            ...styles.toggleSwitch,
            ...(isActive ? styles.toggleSwitchActive : {}),
            opacity: isLoading ? 0.6 : 1,
            cursor: isLoading ? "not-allowed" : "pointer",
          }}
        >
          <div
            style={{
              ...styles.toggleKnob,
              ...(isActive ? styles.toggleKnobActive : {}),
            }}
          />
        </div>
        {isLoading && <SmallSpinner size={14} />}
      </div>
    );
  };

  const CertificateActions = ({ certificate, openMenuId, setOpenMenuId }) => {
    const showMenu = openMenuId === certificate.id;
    const containerRef = useRef(null);

    const handleToggle = () => {
      setOpenMenuId(showMenu ? null : certificate.id);
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          containerRef.current &&
          !containerRef.current.contains(event.target)
        ) {
          setOpenMenuId(null);
        }
      };
      if (showMenu) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showMenu]);

    const handleEditClick = async () => {
      history.push("/events/admin/certificate", {
        state: { isEdit: true, certificate: certificate._originalData },
      });
      setOpenMenuId(null);
    };

    const handleDeleteClick = async () => {
      setCertificateToDelete(certificate);
      setShowDeleteConfirmation(true);
      setOpenMenuId(null);
    };

    return (
      <div style={{ position: "relative" }} ref={containerRef}>
        <button
          onClick={handleToggle}
          style={styles.actionButton}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#e2e8f0";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f1f5f9";
          }}
        >
          <FiMoreVertical size={18} />
        </button>
        {showMenu && (
          <div style={styles.actionMenu}>
            <div
              style={styles.actionMenuItem}
              onClick={handleEditClick}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f8fafc";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <i className="fa fa-edit"></i> Edit
            </div>
            <div
              style={{
                ...styles.actionMenuItem,
                ...styles.actionMenuItemDanger,
              }}
              onClick={handleDeleteClick}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#fef2f2";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <i className="fa fa-trash"></i> Delete
            </div>
          </div>
        )}
      </div>
    );
  };

  const GenerateButton = ({ certificate }) => {
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGenerate = async () => {
      setIsGenerating(true);
      try {
        const payload = {
          id: certificate.id,
          event_id: certificate.event_id,
          event_ticket: certificate.event_ticket || [0],
        };
        const res = await GenarateCertifacate(payload);
        if (res && res.success) {
          showToast("Certificate generated successfully!", "success");
        } else {
          showToast(res.message || "Failed to generate certificate", "error");
        }
      } catch (error) {
        console.error("Error generating certificate:", error);
        showToast("Failed to generate certificate. Please try again.", "error");
      } finally {
        setIsGenerating(false);
      }
    };

    return (
      <button
        onClick={handleGenerate}
        disabled={isGenerating}
        style={{
          ...styles.generateButton,
          opacity: isGenerating ? 0.7 : 1,
        }}
        onMouseEnter={(e) => {
          if (!isGenerating) e.currentTarget.style.backgroundColor = "#163047";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#1e3a5f";
        }}
      >
        {isGenerating ? <SmallSpinner size={14} /> : "Generate"}
      </button>
    );
  };

  const PrintButton = ({ certificate }) => {
    const [isPrinting, setIsPrinting] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewBadges, setPreviewBadges] = useState([]);

    const handlePrinting = async () => {
      setIsPrinting(true);
      try {
        const payload = {
          id: certificate.id,
          event_id: certificate.event_id,
          event_ticket: certificate.event_ticket || [0],
        };
        const res = await printCertificate(payload);
        if (res && res.success) {
          setPreviewBadges(res.certificate || [res]);
          setShowPreview(true);
          showToast("Certificate loaded successfully!", "success");
        } else {
          showToast(res.message || "Failed to load certificate", "error");
        }
      } catch (error) {
        console.error("Error loading certificate:", error);
        showToast("Failed to load certificate. Please try again.", "error");
      } finally {
        setIsPrinting(false);
      }
    };

    return (
      <>
        <button
          onClick={handlePrinting}
          disabled={isPrinting}
          style={{
            ...styles.printButton,
            opacity: isPrinting ? 0.7 : 1,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f8fafc";
            e.currentTarget.style.borderColor = "#1e3a5f";
            e.currentTarget.style.color = "#1e3a5f";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#ffffff";
            e.currentTarget.style.borderColor = "#e2e8f0";
            e.currentTarget.style.color = "#64748b";
          }}
        >
          {isPrinting ? <SmallSpinner size={14} /> : <FaPrint />}
        </button>

        <CertificatePrintPreviewModal
          show={showPreview}
          certificates={previewBadges}
          onClose={() => setShowPreview(false)}
          is_certificate={true}
        />
      </>
    );
  };

  const handleDeleteConfirmed = async () => {
    if (!certificateToDelete) return;
    try {
      const res = await DeleteCertificate(certificateToDelete.id);
      if (res && res.success === true) {
        showToast("Certificate deleted successfully!", "success");
        loadCertificates();
      } else {
        showToast(res.message || "Failed to delete certificate", "error");
      }
    } catch (error) {
      console.error("Error deleting certificate:", error);
      showToast("Failed to delete certificate. Please try again.", "error");
    }
    setCertificateToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const renderHeader = () => (
    <div style={styles.headerCard}>
      <div style={styles.headerLeft}>
        <div style={styles.headerIconBadge}>
          <FaCertificate />
        </div>
        <h2 style={styles.headerTitle}>Certificates</h2>
      </div>
      <button
        onClick={handleNavige}
        style={styles.createButton}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#163047";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#1e3a5f";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <span style={{ fontSize: "18px" }}>+</span> Create Certificate
      </button>
    </div>
  );

  const renderFilters = () => (
    <div style={styles.filterCard}>
      <div style={styles.filterRow}>
        <div style={styles.tabsContainer}>
          {[
            { key: "all", label: "All" },
            { key: "active", label: "Active" },
            { key: "inactive", label: "Inactive" },
          ].map((filter) => (
            <button
              key={filter.key}
              onClick={() => {
                setActiveFilter(filter.key);
                setCurrentPage(1);
              }}
              style={{
                ...styles.tab,
                ...(activeFilter === filter.key ? styles.tabActive : {}),
              }}
              onMouseEnter={(e) => {
                if (activeFilter !== filter.key) {
                  e.currentTarget.style.backgroundColor = "#e2e8f0";
                }
              }}
              onMouseLeave={(e) => {
                if (activeFilter !== filter.key) {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                }
              }}
            >
              {filter.label} ({filterCounts[filter.key]})
            </button>
          ))}
        </div>
        <div style={styles.searchContainer}>
          <FaSearch style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search certificates..."
            value={searchTerm}
            onChange={handleSearch}
            style={styles.searchInput}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = "#1e3a5f";
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          />
        </div>
      </div>
    </div>
  );

  const renderTable = () => (
    <div style={styles.tableCard}>
      {apiError && (
        <div style={styles.errorBanner}>
          <i className="fa fa-exclamation-triangle"></i>
          {apiError}
        </div>
      )}

      <div style={styles.entriesRow}>
        <span style={styles.entriesLabel}>Show Entries</span>
        <select
          value={entriesPerPage}
          onChange={(e) => {
            setEntriesPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
          style={styles.entriesSelect}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>

      {loading ? (
        <div style={styles.loadingContainer}>
          <div style={styles.spinner}></div>
          <p style={styles.loadingText}>Loading certificates...</p>
        </div>
      ) : (
        <>
          <table style={styles.table}>
            <thead style={styles.tableHeader}>
              <tr>
                <th style={styles.th}>Certificate Name</th>
                <th style={styles.th}>Created At</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Generate</th>
                <th style={styles.th}>Print</th>
                <th style={{ ...styles.th, textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedCertificates.map((certificate) => (
                <tr
                  key={certificate.id}
                  style={styles.tr}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f8fafc";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <td style={styles.td}>
                    <div style={styles.certificateNameCell}>
                      <div style={styles.certificateIcon}>
                        <FaCertificate />
                      </div>
                      <span style={styles.certificateTitle}>
                        {certificate.title}
                      </span>
                    </div>
                  </td>
                  <td style={styles.td}>{certificate.created_at}</td>
                  <td style={styles.td}>
                    <StatusToggle
                      status={certificate.status}
                      certificateId={certificate.id}
                      CertificateTitle={certificate.title}
                      certificateTemplate={certificate.template}
                    />
                  </td>
                  <td style={styles.td}>
                    <GenerateButton certificate={certificate} />
                  </td>
                  <td style={styles.td}>
                    <PrintButton certificate={certificate} />
                  </td>
                  <td style={{ ...styles.td, textAlign: "center" }}>
                    <CertificateActions
                      certificate={certificate}
                      openMenuId={openMenuId}
                      setOpenMenuId={setOpenMenuId}
                    />
                  </td>
                </tr>
              ))}
              {paginatedCertificates.length === 0 && (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      ...styles.td,
                      textAlign: "center",
                      padding: "40px",
                    }}
                  >
                    No certificates found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div style={styles.paginationContainer}>
            <span style={styles.paginationInfo}>
              Showing{" "}
              {filteredCertificates.length === 0
                ? 0
                : (currentPage - 1) * entriesPerPage + 1}{" "}
              to{" "}
              {Math.min(
                currentPage * entriesPerPage,
                filteredCertificates.length
              )}{" "}
              of {filteredCertificates.length} entries
            </span>
            <div style={styles.paginationButtons}>
              <button
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                  ...styles.pageButton,
                  opacity: currentPage === 1 ? 0.5 : 1,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                Previous
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    style={{
                      ...styles.pageButton,
                      ...(currentPage === page ? styles.pageButtonActive : {}),
                    }}
                  >
                    {page}
                  </button>
                )
              )}
              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(totalPages, p + 1))
                }
                disabled={currentPage === totalPages || totalPages === 0}
                style={{
                  ...styles.pageButton,
                  opacity:
                    currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
                  cursor:
                    currentPage === totalPages || totalPages === 0
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );

  return (
    <>
      <div style={styles.container}>
        <ToastMessage />
        {renderHeader()}
        {renderFilters()}
        {renderTable()}
        <ConfirmationModal
          show={showDeleteConfirmation}
          title="Delete Certificate"
          message={`Are you sure you want to delete the certificate "${certificateToDelete?.title}"? This action cannot be undone.`}
          confirmButtonText="Delete"
          confirmButtonVariant="danger"
          onConfirm={handleDeleteConfirmed}
          onCancel={() => {
            setShowDeleteConfirmation(false);
            setCertificateToDelete(null);
          }}
        />
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default CertificateList;
